<script>
    import { selectedHostingPlan } from '../stores.js';
    import Rating from './Rating.svelte';

    export let plan;
    export let isSelected;

    function toggle() {
		isSelected = !isSelected;
	}

    function setSelected() {
        $selectedHostingPlan = plan;
	}
</script>


<div class="tile {$selectedHostingPlan === plan ? 'active' : ''}" on:click={toggle} on:click={setSelected}>
    <h2>{plan.title}</h2>
    <div class="description">
        {@html plan.description}
    </div>
    <div class="ratings">
        <span>Vitesse</span><Rating max={4} value="{plan.speed}"/>        
        <span>Puissance</span><Rating max={4} value="{plan.power}"/>
    </div>
    <div class="pricing">
        {#if plan.custom}
            <span class="price-info">À partir de</span> <span class="price">{plan.price}€</span><br>
            <span class="price-info">ht/mois</span>
        {:else}
            <span class="price">{plan.price}€</span><br>
            <span class="price-info">ht/mois</span>
        {/if}
    </div>
</div>


<style>
    h2 {
        margin-top: 0;
        font-family: Georgia, 'Times New Roman', Times, serif;

    }
    .tile {
        border: solid 5px transparent;
        padding: 24px 40px;
        background: #fff;
        cursor: pointer;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    }
    .tile.active {
        border: solid 5px #10284B;
    }
    .description{
        color: #859DB7;
        min-height: 90px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .ratings{
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        column-gap: 10px;
        justify-items: start;
        margin: 16px 0;
        display: none;
    }
    span{
        width: 100%;
        text-align: end;
    }
    .pricing {
        margin-top: 10px;
    }
    .price{
        font-weight: bold;
        font-size: 18px;
        font-family: Georgia, 'Times New Roman', Times, serif;
    }
    .price-info {
        color: #859DB7;
        font-size: 14px;
    }
</style>
